<template>
    <v-sheet class="mx-auto fill-height fill-width" max-width="700">

        <!-- 리스트 없을경우 -->
        <div v-if="getSquareCmntListResult.length === 0" class="pos-center text-center pb-15">
            <Bell/>
            <div class="fs-14 secondary--text mt-3">댓글이 없습니다.</div>
        </div>
        <ul class="list" v-else>
            <li v-for="(item, index) in getSquareCmntListResult" :key="index">
                <div class="item" @click="readOne(item.cmntSquareNo)">
                    <div class="content">
                        cmntNo : <div class="text" v-text="item.cmntNo"></div>
                        cmntSquareNo : <div class="text" v-text="item.cmntSquareNo"></div>
                        cmntContent : <div class="text" v-text="item.cmntContent"></div>
                        cmntCmntCnt : <div class="text" v-text="item.cmntCmntCnt"></div>
                        cmntRegNm : <div class="text" v-text="item.cmntRegNm"></div>
                    </div>
                    <div>
                        <BlackBtn str="삭제" @click="deleteSquare(item.cmntSquareNo)"></BlackBtn>
                    </div>
                </div>
            </li>
        </ul>
        <div class="gray--text">
            번호 : {{ $route.params.squareNo }}
            <input type="text" placeholder="조회수" v-model="searchCnt"/>
            <input type="text" placeholder="칭찬해요수" v-model="praiseCnt"/>
            <input type="text" placeholder="노출여부" v-model="expsYn"/>
            <textarea v-model="content" placeholder="내용" cols="40" rows="5"></textarea>

            <BlackBtn str="작성" @click="create"></BlackBtn>
            <BlackBtn str="수정" @click="updateSquare"></BlackBtn>
        </div>
    </v-sheet>
</template>

<script>
import Bell from '@/components/icons/Bell'
import BlackBtn from "@/components/btns/BlackBtn";
import store from '../../store'
import { longStackSupport } from 'q';
export default {
    data: ()=> ({
      selectedItem: 1,
      getSquareCmntListResult: {},
      successResult: '',
      squareNoVal: 0,
      deleteResult: '',
      searchCnt: '',
      praiseCnt: '',
      expsYn: '',
      content: '',
    //   squareNo: '',

    }),
    props: {
        squareNo: {
            type: longStackSupport,
            default: 0
        }
    },
    components: {
        Bell,
        BlackBtn,
    },
    created () {
        this.readList()
    },
    methods:{
        async readList () {
            await store.dispatch('getSquareCmntList', this.$_payload({'squareNo': this.$route.params.squareNo}))
                .then(res => {
                if (res.success) {
                    this.getSquareCmntListResult = res.data
                } else {
                    console.log(res.msg)
                    this.getSquareCmntListResult = ''
                }
                })
                .catch(error => {
                console.error(error)
                this.getSquareCmntListResult = ''
                })
                .finally(() => {})
                },
        async readOne (squareNoVal) {
            await store.dispatch('getSquareOne', this.$_payload({'squareNo': squareNoVal}))
                .then(res => {
                if (res.success) {
                    this.searchCnt = res.data.searchCnt
                    this.praiseCnt = res.data.praiseCnt
                    this.expsYn = res.data.expsYn
                    this.squareNo = res.data.squareNo
                    this.content = res.data.content
                } else {
                    console.log(res.msg)
                    this.searchCnt = ''
                    this.praiseCnt = ''
                    this.expsYn = ''
                    this.squareNo = ''
                    this.content = ''
                }
                })
                .catch(error => {
                console.error(error)
                this.searchCnt = ''
                this.praiseCnt = ''
                this.expsYn = ''
                this.squareNo = ''
                this.content = ''
                })
                .finally(() => {})
                },
        async create () {
            await store.dispatch('setSquarePostRegist', this.$_payload('ba',{
                    searchCnt:this.searchCnt,
                    praiseCnt:this.praiseCnt,
                    expsYn:this.expsYn,
                    content:this.content
                }))
                .then(res => {
                    if (res.success) {
                        this.successResult = res.data
                    } else {
                        console.log(res.msg)
                        this.successResult = ''
                    }
                })
                .catch(error => {
                console.error(error)
                this.successResult = ''
                })
                .finally(() => {})
                },
        async updateSquare () {
            await store.dispatch('setSquarePostModify', this.$_payload({'squareNo': this.squareNo}, {
                    searchCnt: this.searchCnt,
                    praiseCnt: this.praiseCnt,
                    expsYn: this.expsYn,
                    squareNo: this.squareNo,
                    content: this.content
                }))
                .then(res => {
                    if (res.success) {
                        this.successResult = res.data
                    } else {
                        console.log(res.msg)
                        this.successResult = ''
                    }
                })
                .catch(error => {
                console.error(error)
                this.successResult = ''
                })
                .finally(() => {})
                },
        async deleteSquare (squareNoVal) {
            await store.dispatch('setSquarePostDelete', this.$_payload({'squareNo': squareNoVal}))
                .then(res => {
                    if (res.success) {
                        this.deleteResult = res.data
                    } else {
                        console.log(res.msg)
                        this.deleteResult = ''
                    }
                })
                .catch(error => {
                console.error(error)
                this.deleteResult = ''
                })
                .finally(() => {})
                }
    }
}
</script>

<style lang="scss" scoped>
.list{
    padding:0;
    li{
        padding: 18px 23px 0 23px;
        .item{
            display: flex;
            flex: 1 1 100%;
            border-bottom: 1px solid #E6E8EA;
            justify-content: space-between;
            padding-bottom: 18px;
            .icon{
                width: 30px;
                height: 30px;
                border-radius: 50%;
                overflow: hidden;
                margin-top: 5px;
            }
            .content{
                width: calc(100% - 42px);
                .date{
                    font-size: 12px;
                    color: #545457;
                    margin-top: 5px;
                }
            }
        }
        &.new{
            background: $color-sub;
        }
        &:last-child{
            .item{
                border-bottom: none;
            }
        }

    }
}

</style>
